import { useState } from "react";

/**
 * `[start, end]` covering today's local midnight through the last millisecond
 * of the `dayCount`-th calendar day.
 *
 * The end is found by walking calendar days with `setDate`, not by adding
 * `dayCount * 24h`: across the night the clocks go back that arithmetic ends
 * the window an hour early and drops the last hour of the final day from the
 * calendar query; across the night they go forward it reaches an hour into the
 * day after.
 */
export const useDateBoundary = (dayCount: number) => {
    return useState(() => {
        const start = new Date();
        start.setHours(0, 0, 0, 0);
        const end = new Date(start);
        end.setDate(end.getDate() + dayCount);
        end.setTime(end.getTime() - 1);
        return { start, end };
    });
};
